import { moveActivePlayerIndicator } from '../Game/Game';
import styled from 'styled-components';

interface IActivePlayer {
  activePlayer: number | null;
  selectedPlayer: number | null;
}

const StyledActivePlayer = styled.div<{
  position: { left: string; top: string };
  isActive: boolean | false;
}>`
  background-color: magenta;
  width: 50px;
  height: 50px;
  left: ${(props) => props.position.left};
  top: ${(props) => props.position.top};
  position: absolute;
  border-radius: 50px;
  margin: 20px 10px 10px 10px;
  border: solid black 3px;
  cursor: ${(props) => (props.isActive ? 'pointer' : 'default')};
`;

export default function ActivePlayer(props: IActivePlayer) {
  const { activePlayer, selectedPlayer } = props;

  let position = { left: '465px', top: '100px' };
  if (activePlayer === null || selectedPlayer === null) {
    return <div></div>;
  }
  switch ((activePlayer - selectedPlayer + 4) % 4) {
    case 0:
      position = { left: '100px', top: '465px' };
      break;
    case 1:
      position = { left: '100px', top: '100px' };
      break;
    case 2:
      position = { left: '465px', top: '100px' };
      break;
    case 3:
      position = { left: '465px', top: '465px' };
      break;
  }

  let indicator = <div></div>;
  if (activePlayer !== null) {
    indicator = (
      <StyledActivePlayer
        isActive={activePlayer === selectedPlayer}
        position={position}
        onClick={
          activePlayer === selectedPlayer
            ? moveActivePlayerIndicator
            : undefined
        }
      >
        {activePlayer === selectedPlayer ? 'Click me when finished!' : ''}
      </StyledActivePlayer>
    );
  }
  return indicator;
}
